"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndiciesClient = void 0;
class IndiciesClient {
    constructor(client) {
        this.client = client;
    }
    /**
     * Create a new vector similarity search index in the database.
     * @param config Configuration for the vector index.
     * @param runWithOrchestration Whether to run index creation as an orchestrated task.
     * @returns
     */
    async create(options) {
        const data = Object.assign({ config: options.config }, (options.runWithOrchestration !== undefined && {
            run_with_orchestration: options.runWithOrchestration,
        }));
        return this.client.makeRequest("POST", `indices`, {
            data,
        });
    }
    /**
     * List existing vector similarity search indices with pagination support.
     * @param filters Filter criteria for indices.
     * @param offset Specifies the number of objects to skip. Defaults to 0.
     * @param limit Specifies a limit on the number of objects to return, ranging between 1 and 100. Defaults to 100.
     * @returns
     */
    async list(options) {
        var _a, _b;
        const params = {
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : 0,
            limit: (_b = options === null || options === void 0 ? void 0 : options.limit) !== null && _b !== void 0 ? _b : 100,
        };
        if (options === null || options === void 0 ? void 0 : options.filters) {
            params.filters = options.filters;
        }
        return this.client.makeRequest("GET", `indices`, {
            params,
        });
    }
    /**
     * Get detailed information about a specific vector index.
     * @param indexName The name of the index to retrieve.
     * @param tableName The name of the table where the index is stored.
     * @returns
     */
    async retrieve(options) {
        return this.client.makeRequest("GET", `indices/${options.indexName}/${options.tableName}`);
    }
    /**
     * Delete an existing vector index.
     * @param indexName The name of the index to delete.
     * @param tableName The name of the table where the index is stored.
     * @returns
     */
    async delete(options) {
        return this.client.makeRequest("DELETE", `indices/${options.indexName}/${options.tableName}`);
    }
}
exports.IndiciesClient = IndiciesClient;
//# sourceMappingURL=indices.js.map